import React from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { clearAllAlerts } from '../../actions/alerts'

const NotFound = (props) => {
  return (
    <div className="not-found">
      <h1>Not Found</h1>

      <NavLink to={`/library`} onClick={() => props.clearAllAlerts()}>← Home</NavLink>
    </div>
  )
}

NotFound.propTypes = {
  object: PropTypes.object
}

NotFound.defaultProps = {
  object: {}
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    clearAllAlerts
  }, dispatch)
}

export default connect(undefined, mapDispatchToProps)(NotFound)



// WEBPACK FOOTER //
// ./src/components/common/not-found.js